import styles from './FullScreenSpinner.module.css';

export default function CenterSpinner() {
  return (
    <div className={styles.spinner}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
